var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-card',[_c('calendar-validation'),_c('calendar-vertical',{on:{"display-update":_vm.onDisplayUpdateDialog}}),_c('update-calendar-dialog',{attrs:{"options":_vm.updateDialog},on:{"update:options":function($event){_vm.updateDialog=$event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }